import React from "react";
import { isEmpty } from "lodash";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialBookUpdate from "../social_book_update";
import UserStatusHeader from "./user_status_header";
import UserStatusDetails from "./user_status_details";
import BookDescription from "../../book_description";
import PreviewBook from "../../preview_book/preview_book";

export default GrComponentFactory.createClass({
  displayName: "UserStatusNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
    }).isRequired,
  },

  hasStatusText() {
    return !isEmpty(this.props.resource.userStatusText);
  },

  renderBookBody() {
    return (
      <div>
        <BookDescription className="u-marginTopXSmall" bookDescription={this.props.resource.book.description} />
      </div>
    );
  },

  render() {
    const resource = this.props.resource;
    const header = <UserStatusHeader book={this.props.resource.book}
                                   headerText={resource.headerText}/>;

    return <SocialBookUpdate
      header={header}
      book={this.props.resource.book}
      bookBody={this.renderBookBody()}
      updateDetails={<UserStatusDetails {...resource}/>}
      additionalFooterLinks={[<PreviewBook book={this.props.resource.book}/>]}
      showBookBorder={this.hasStatusText()}
      {...this.props}
      />;
  },
});
